import React, { Component } from 'react';
import * as firebase from "firebase";
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ChatIcon from 'material-ui/svg-icons/communication/chat';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
var getScreenMedia = require('getscreenmedia');

class Student extends Component {
  constructor(props) {
    super(props);
    this.state = {
      remote_video: "",
      error_screen: false,
      memeber_count: 0,
      room_notice: "Creating a Mentor Room",
      open_chat_head: false,
      chat_array: []
    };
    this.sendMessage = this.sendMessage.bind(this);
    this.readMessage = this.readMessage.bind(this);
    this.showMyFace = this.showMyFace.bind(this);
    this.showFriendsFace = this.showFriendsFace.bind(this);
  }

  componentDidMount() {
    this.roomDatabaseref = firebase.database().ref("hand_rooms/" + this.props.match.params.room_id);
    this.roomDatabaseref.on("value",(roomSnap) => {
      debugger;
      if(roomSnap.val() != null){
        this.setState({room_notice: "Room Exist."});
        if(roomSnap.val().student){
          this.setState({room_notice: "Room Exist, Student already exist. Please verify room id."});
        }else {
          this.roomDatabaseref.child("student").set(true).then(() => {
            this.setState({room_created: true,room_notice: "Created room successfully, waiting for Mentor."})
            window.addEventListener("beforeunload", (ev) =>
            {
                ev.preventDefault();
                this.roomDatabaseref.child("student").set(null);
                return ev.returnValue = 'Are you sure you want to close?';
            });
          });
        }
      }else {
        this.setState({room_created: false,room_notice: "Room does not exist or is closed, Please verify room ID."})
      }
    });
  }

  componentWillUnmount() {}

  componentDidUpdate(prevProps, prevState) {
    if(prevState.room_created !== this.state.room_created && this.state.room_created) {
      this.roomDatabaseref.child("chat/student").on("value", (snapshot) => {
        var newChat = snapshot.val();
        if(newChat){
            if(!this.state.open_chat_head)
              this.setState({
                open_chat_head: !this.state.open_chat_head,
                anchorEl:this.chatHeadref
              });
            var chat_list = this.state.chat_array;
            chat_list.push(<p className="chat-rec">{newChat}</p>)
            this.setState({chat_array: chat_list});
        }
        console.log("The updated post title is " + newChat);
      });
      this.signalDBRef = firebase.database().ref("hand_rooms/"+this.props.match.params.room_id+"/signals");
      this.yourVideo = document.getElementById("yourVideo");
      this.mentorVideo = document.getElementById("mentorVideo");
      this.yourId = Math.floor(Math.random()*1000000000);
      var servers = {
        'iceServers': [
          {'urls': 'stun:35.154.192.229'},
          {'urls': 'turn:35.154.192.229','credential': 'password','username': 'pavi'},
          {'urls': 'turn:35.154.192.229?transport=tcp','credential': 'password','username': 'pavi'},
          {'urls': 'turn:35.154.192.229:443','credential': 'password','username': 'pavi'},
          {'urls': 'turn:35.154.192.229:443?transport=tcp','credential': 'password','username': 'pavi'}]};;
      this.pc = new RTCPeerConnection(servers);
      this.showMyFace();
      this.pc.onicecandidate = (event => event.candidate?this.sendMessage(this.yourId, JSON.stringify({'ice': event.candidate})):console.log("Sent All Ice") );
      this.pc.onaddstream = (event => this.mentorVideo.srcObject = event.stream);

      this.signalDBRef.on('child_added', this.readMessage);
    }
  }

  sendMessage(senderId, data) {
      var msg = this.signalDBRef.push({ sender: senderId, message: data });
      msg.remove();
  }

  readMessage(data) {
      var msg = JSON.parse(data.val().message);
      var sender = data.val().sender;
      if (sender !== this.yourId) {
          if (msg.ice !== undefined)
              this.pc.addIceCandidate(new RTCIceCandidate(msg.ice));
          else if (msg.sdp.type === "offer")
              this.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp))
                .then(() => this.pc.createAnswer())
                .then(answer => this.pc.setLocalDescription(answer))
                .then(() => this.sendMessage(this.yourId, JSON.stringify({'sdp': this.pc.localDescription})));
          else if (msg.sdp.type === "answer")
              this.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp));
      }
  };

  showMyFace() {
    //.then(audioStream => this.yourVideo.srcObject = audioStream)
    navigator.mediaDevices.getUserMedia({audio:true})
      .then(audioStream => {
        getScreenMedia((err, screenStream) => {
            if (err) {
                alert("Couldn't Share Screen");
                console.log('failed');
            } else {
                this.yourVideo.srcObject = screenStream;
                var audioTrack = audioStream.getAudioTracks()[0];

                // add audio tracks into screen stream
                screenStream.addTrack( audioTrack );
                // console.log('got a stream', stream);
                this.pc.addStream(screenStream);
            }
        });
      });
  }

  /*showMyScreen() {
    window.getScreenId((error, sourceId, screen_constraints) => {
        // error    == null || 'permission-denied' || 'not-installed' || 'installed-disabled' || 'not-chrome'
        // sourceId == null || 'string' || 'firefox'

        if(error == 'not-installed') {
          alert('Please install Chrome extension.');
          return;
        }

        navigator.getUserMedia = navigator.mozGetUserMedia || navigator.webkitGetUserMedia;
        navigator.getUserMedia(screen_constraints, (stream) => {
            this.yourVideo.srcObject = stream;
            this.pc.addStream(stream);
        }, function (error) {
          console.error('getScreenId error', error);

          alert('Failed to capture your screen. Please check Chrome console logs for further information.');
        });
    });
    getScreenMedia((err, stream) => {
        if (err) {
           console.log('failed');
        } else {
          this.yourVideo.srcObject = stream;
           // console.log('got a stream', stream);
        }
    });
  }*/

  showFriendsFace() {
    this.pc.createOffer()
      .then(offer => this.pc.setLocalDescription(offer) )
      .then(() => this.sendMessage(this.yourId, JSON.stringify({'sdp': this.pc.localDescription})) );
  }

  render() {
    return (
      <div>
        {!this.state.room_created &&
          <p
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
          }}
          >
          {this.state.room_notice}
          </p>}
        {this.state.room_created &&
          (<div className="student">
              <video id="yourVideo" autoPlay muted></video>
              <video id="mentorVideo" autoPlay></video>
              <MuiThemeProvider >
                <div>
                  <FloatingActionButton
                    onClick={(event) => this.showFriendsFace()}
                    style={{
                      position: 'fixed',
                      top: 15,
                      right: 15,
                      zIndex: 2
                    }}>
                    <ChatIcon />
                  </FloatingActionButton>
                  {/*<FloatingActionButton
                    onClick={(event) => this.showMyScreen()}
                    style={{
                      position: 'fixed',
                      bottom: 15,
                      right: 15,
                      zIndex: 2
                    }}>
                    Screen Share
                  </FloatingActionButton>*/}
                </div>
              </MuiThemeProvider >
            </div>)
        }
      </div>
    );
  }
}
export default Student;



// WEBPACK FOOTER //
// ./src/Student.js